'use client';

import React from 'react';
import { RECENTLY_VIEWED_PRODUCTS_KEY } from '@skin-seoul/service';
import SkinSeoulSelectsSection from '../SkinSeoulSelectsSection/SkinSeoulSelectsSection';
import RecentlyViewedSection from '../RecentlyViewedSection/RecentlyViewedSection';
import Cookies from 'js-cookie';
import { useProductService } from '@skin-seoul/service';
import { ProductStockStatus } from '@skin-seoul/service';
import { useRegionCurrency } from '@skin-seoul/service';
const ConditionalRecentlyViewedSection = () => {
  /**
   * Read recently viewed product ids from cookie.
   * If the cookie exists but cannot be parsed into a valid non-empty id array,
   * we consider it invalid and remove the cookie immediately.
   */
  const rawRecentlyViewed = Cookies.get(RECENTLY_VIEWED_PRODUCTS_KEY);
  const recentlyViewedIds = rawRecentlyViewed?.split('|').filter(Boolean) || [];
  if (!rawRecentlyViewed || recentlyViewedIds.length === 0) {
    Cookies.remove(RECENTLY_VIEWED_PRODUCTS_KEY);
  }
  const {
    currency
  } = useRegionCurrency();
  const {
    useGetSuspenseProductsByIds: useGetProductsByIds
  } = useProductService();
  const {
    data: recentlyViewedData
  } = useGetProductsByIds({
    ids: recentlyViewedIds.join(','),
    currency
  });
  const filteredRecentlyViewedProducts = recentlyViewedData?.filter(product => product.status === ProductStockStatus.instock);
  if (!filteredRecentlyViewedProducts || filteredRecentlyViewedProducts.length === 0) {
    Cookies.remove(RECENTLY_VIEWED_PRODUCTS_KEY);
    return <SkinSeoulSelectsSection />;
  }
  return <RecentlyViewedSection recentlyViewedProducts={filteredRecentlyViewedProducts} data-sentry-element="RecentlyViewedSection" data-sentry-component="ConditionalRecentlyViewedSection" data-sentry-source-file="ConditionalRecentlyViewedSection.tsx" />;
};
export default ConditionalRecentlyViewedSection;